/* Orthomen landing page behaviour — vanilla JS, section-scoped, idempotent.
   Progressive enhancement: the product form posts natively without JS. */
(function () {
  'use strict';

  var INIT_FLAG = 'orthomenInit';

  /* ---------- helpers ---------- */
  function formatMoney(cents, format) {
    var amount = (cents / 100).toFixed(2);
    var fmt = format || '${{amount}}';
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toString());
  }

  /* Derive a money format from a server-rendered price string (e.g. "£8.00")
     so client-side totals always match the presentment currency. */
  function formatFromRendered(text, fallback) {
    if (!text) return fallback;
    var m = text.trim().match(/^([^\d]*)([\d., \s]*\d)([^\d]*)$/);
    if (!m) return fallback;
    return m[1] + '{{amount}}' + m[3];
  }

  function dispatch(name, detail) {
    document.dispatchEvent(new CustomEvent(name, { detail: detail }));
  }

  /* ================= HERO ================= */
  function initHero(root) {
    if (root.dataset[INIT_FLAG]) return;
    root.dataset[INIT_FLAG] = 'true';

    var productId = root.dataset.productId;
    var moneyFormat = root.dataset.moneyFormat || '${{amount}}';
    var variantScript = root.querySelector('[data-orthomen-variants]');
    var variants = [];
    try { variants = variantScript ? JSON.parse(variantScript.textContent) : []; } catch (e) { variants = []; }

    var state = { qty: 1, variant: null };

    /* ----- gallery ----- */
    var gallery = root.querySelector('[data-orthomen-gallery]');
    var slides = gallery ? Array.prototype.slice.call(gallery.querySelectorAll('[data-slide]')) : [];
    var thumbs = gallery ? Array.prototype.slice.call(gallery.querySelectorAll('[data-thumb]')) : [];
    var counter = gallery ? gallery.querySelector('[data-counter]') : null;
    var current = 0;

    function showSlide(i) {
      if (!slides.length) return;
      current = ((i % slides.length) + slides.length) % slides.length;
      slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === current); });
      thumbs.forEach(function (t, idx) {
        t.classList.toggle('is-active', idx === current);
        t.setAttribute('aria-current', idx === current ? 'true' : 'false');
      });
      if (counter) counter.textContent = (current + 1) + ' / ' + slides.length;
      var lbImg = root.querySelector('[data-lightbox-img]');
      if (lbImg) {
        var src = slides[current].getAttribute('data-full') || '';
        if (src) { lbImg.src = src; lbImg.alt = slides[current].getAttribute('data-alt') || ''; }
      }
    }
    if (gallery) {
      var prev = gallery.querySelector('[data-gallery-prev]');
      var next = gallery.querySelector('[data-gallery-next]');
      if (prev) prev.addEventListener('click', function () { showSlide(current - 1); });
      if (next) next.addEventListener('click', function () { showSlide(current + 1); });
      thumbs.forEach(function (t, idx) { t.addEventListener('click', function () { showSlide(idx); }); });
      gallery.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { showSlide(current - 1); }
        if (e.key === 'ArrowRight') { showSlide(current + 1); }
      });
      var lightbox = root.querySelector('[data-orthomen-lightbox]');
      var zoomBtn = gallery.querySelector('[data-gallery-zoom]');
      if (lightbox && zoomBtn && typeof lightbox.showModal === 'function') {
        zoomBtn.addEventListener('click', function () { showSlide(current); lightbox.showModal(); });
        var closeBtn = lightbox.querySelector('[data-lightbox-close]');
        if (closeBtn) closeBtn.addEventListener('click', function () { lightbox.close(); });
        lightbox.addEventListener('click', function (e) { if (e.target === lightbox) lightbox.close(); });
      } else if (zoomBtn) { zoomBtn.hidden = true; }
      showSlide(0);
      var touchX = null;
      gallery.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; }, { passive: true });
      gallery.addEventListener('touchend', function (e) {
        if (touchX === null) return;
        var dx = e.changedTouches[0].clientX - touchX;
        if (Math.abs(dx) > 40) showSlide(dx > 0 ? current - 1 : current + 1);
        touchX = null;
      }, { passive: true });
    }

    /* ----- variants ----- */
    var optionInputs = Array.prototype.slice.call(root.querySelectorAll('[data-option-input]'));
    var idInputs = Array.prototype.slice.call(root.querySelectorAll('input[name="id"]'));
    var priceEl = root.querySelector('[data-orthomen-price]');
    var compareEl = root.querySelector('[data-orthomen-compare]');
    var badgeEl = root.querySelector('[data-orthomen-badge]');
    var badgePrefix = badgeEl ? (badgeEl.dataset.savePrefix || 'SAVE') : 'SAVE';
    var atcBtn = root.querySelector('[data-orthomen-atc]');
    var atcLabel = atcBtn ? atcBtn.querySelector('[data-atc-label]') : null;
    var atcPrice = atcBtn ? atcBtn.querySelector('[data-atc-price]') : null;
    var soldOutText = root.dataset.soldOutText || 'Sold out';
    var atcText = root.dataset.atcText || 'Add to cart';

    /* prefer the format of the server-rendered price (matches presentment currency) */
    moneyFormat = formatFromRendered(priceEl && priceEl.textContent, moneyFormat);

    function selectedOptions() {
      var opts = {};
      optionInputs.forEach(function (inp) { if (inp.checked) opts[inp.dataset.optionName] = inp.value; });
      return opts;
    }

    function matchVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (val, i) { return opts[v.option_names[i]] === val; });
      }) || null;
    }

    function updateAvailabilityUI(opts) {
      optionInputs.forEach(function (inp) {
        var test = {};
        Object.keys(opts).forEach(function (k) { test[k] = opts[k]; });
        test[inp.dataset.optionName] = inp.value;
        var exists = false, available = false;
        variants.forEach(function (v) {
          var match = v.options.every(function (val, i) { return test[v.option_names[i]] === val; });
          if (match) { exists = true; if (v.available) available = true; }
        });
        var label = inp.closest('.orthomen-options__label, .orthomen-sticky__pill');
        if (label) label.classList.toggle('is-unavailable', exists && !available);
      });
    }

    function applyVariant(v, fromUser) {
      state.variant = v;
      if (!v) return;
      idInputs.forEach(function (inp) {
        inp.value = v.id;
        inp.dispatchEvent(new Event('change', { bubbles: true }));
      });
      if (priceEl) priceEl.textContent = formatMoney(v.price, moneyFormat);
      if (compareEl) compareEl.textContent = v.compare_at_price > v.price ? formatMoney(v.compare_at_price, moneyFormat) : '';
      if (badgeEl) {
        badgeEl.textContent = v.compare_at_price > v.price ? (badgePrefix + ' ' + formatMoney(v.compare_at_price - v.price, moneyFormat)) : '';
      }
      if (atcBtn) {
        atcBtn.disabled = !v.available;
        if (atcLabel) atcLabel.textContent = v.available ? atcText : soldOutText;
      }
      updateTotals();
      if (v.media_index != null && v.media_index >= 0 && fromUser) showSlide(v.media_index);
      if (fromUser && window.history && window.history.replaceState) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) { /* noop */ }
      }
      updateAvailabilityUI(selectedOptions());
      dispatch('orthomen:variant', { productId: productId, variant: v, qty: state.qty, moneyFormat: moneyFormat });
    }

    function updateTotals() {
      if (atcPrice && state.variant) atcPrice.textContent = formatMoney(state.variant.price * state.qty, moneyFormat);
    }

    optionInputs.forEach(function (inp) {
      inp.addEventListener('change', function () { applyVariant(matchVariant(selectedOptions()), true); });
    });

    /* ----- quantity ----- */
    var qtyInput = root.querySelector('[data-orthomen-qty]');
    if (qtyInput) {
      var syncQty = function (n) {
        n = Math.max(1, Math.min(parseInt(qtyInput.max || '99', 10) || 99, n || 1));
        qtyInput.value = n;
        state.qty = n;
        updateTotals();
        dispatch('orthomen:qty', { productId: productId, qty: n });
      };
      var dec = root.querySelector('[data-qty-dec]');
      var inc = root.querySelector('[data-qty-inc]');
      if (dec) dec.addEventListener('click', function () { syncQty(state.qty - 1); });
      if (inc) inc.addEventListener('click', function () { syncQty(state.qty + 1); });
      qtyInput.addEventListener('change', function () { syncQty(parseInt(qtyInput.value, 10)); });
      state.qty = parseInt(qtyInput.value, 10) || 1;
    }

    /* external variant set (sticky bar pills) */
    var onExternalSet = function (e) {
      if (!e.detail || String(e.detail.productId) !== String(productId)) return;
      var v = variants.find(function (x) { return String(x.id) === String(e.detail.variantId); });
      if (!v) return;
      v.options.forEach(function (val, i) {
        var name = v.option_names[i];
        optionInputs.forEach(function (inp) {
          if (inp.dataset.optionName === name) inp.checked = (inp.value === val);
        });
      });
      applyVariant(v, true);
    };
    document.addEventListener('orthomen:variant:set', onExternalSet);
    root.orthomenCleanup = function () { document.removeEventListener('orthomen:variant:set', onExternalSet); };

    /* initial state from server-rendered checked inputs */
    var initial = matchVariant(selectedOptions());
    if (!initial && variants.length) initial = variants.filter(function (v) { return v.available; })[0] || variants[0];
    applyVariant(initial, false);
  }

  /* ================= STICKY ATC ================= */
  function initSticky(root) {
    if (root.dataset[INIT_FLAG]) return;
    root.dataset[INIT_FLAG] = 'true';

    var productId = root.dataset.productId;
    var alwaysVisible = root.dataset.alwaysVisible === 'true';
    var bar = root.querySelector('.orthomen-sticky');
    if (!bar) return;
    var metaEl = root.querySelector('[data-sticky-meta]');
    var priceInMeta = root.querySelector('[data-sticky-price]');
    var btn = root.querySelector('[data-sticky-atc]');
    var btnPrice = root.querySelector('[data-sticky-btn-price]');
    var thumbImg = root.querySelector('[data-sticky-thumb] img');
    var pills = Array.prototype.slice.call(root.querySelectorAll('[data-sticky-pill]'));
    var initialFormat = formatFromRendered(
      (priceInMeta && priceInMeta.textContent) || (btnPrice && btnPrice.textContent),
      root.dataset.moneyFormat || '${{amount}}'
    );
    var state = { variant: null, qty: 1, moneyFormat: initialFormat };

    function setVisible(v) {
      bar.classList.toggle('is-visible', v);
      document.body.style.paddingBottom = v ? (bar.offsetHeight + 'px') : '';
    }

    if (alwaysVisible || document.documentElement.classList.contains('shopify-design-mode')) {
      setVisible(true);
    } else {
      var anchor = document.querySelector('[data-orthomen-cta-anchor][data-product-id="' + productId + '"]') ||
        document.querySelector('[data-orthomen-cta-anchor]');
      if (anchor && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) { setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0 || !entry.isIntersecting && entry.boundingClientRect.bottom < window.innerHeight); });
        }, { threshold: 0 });
        io.observe(anchor);
        root.orthomenObserver = io;
      } else {
        setVisible(true);
      }
    }

    function refresh() {
      var v = state.variant;
      if (!v) return;
      var priceStr = formatMoney(v.price, state.moneyFormat);
      if (metaEl) metaEl.textContent = (v.title !== 'Default Title' ? v.title + ' · ' : '') + priceStr;
      if (priceInMeta) priceInMeta.textContent = priceStr;
      if (btnPrice) btnPrice.textContent = formatMoney(v.price * state.qty, state.moneyFormat);
      if (btn) btn.disabled = !v.available;
      pills.forEach(function (p) {
        var on = String(p.dataset.variantId) === String(v.id);
        p.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      if (thumbImg && v.media_src) thumbImg.src = v.media_src;
    }

    var onVariant = function (e) {
      if (!e.detail || String(e.detail.productId) !== String(productId)) return;
      state.variant = e.detail.variant;
      state.qty = e.detail.qty || state.qty;
      if (e.detail.moneyFormat) state.moneyFormat = e.detail.moneyFormat;
      refresh();
    };
    var onQty = function (e) {
      if (!e.detail || String(e.detail.productId) !== String(productId)) return;
      state.qty = e.detail.qty || 1;
      refresh();
    };
    document.addEventListener('orthomen:variant', onVariant);
    document.addEventListener('orthomen:qty', onQty);

    pills.forEach(function (p) {
      p.addEventListener('click', function () {
        dispatch('orthomen:variant:set', { productId: productId, variantId: p.dataset.variantId });
      });
    });

    var submitting = false;
    if (btn) {
      btn.addEventListener('click', function () {
        if (submitting) return;
        var heroBtn = document.querySelector('[data-orthomen-atc][data-product-id="' + productId + '"]') ||
          document.querySelector('.orthomen [data-orthomen-atc]');
        if (heroBtn && !heroBtn.disabled) {
          submitting = true;
          btn.setAttribute('aria-busy', 'true');
          heroBtn.click();
          window.setTimeout(function () { submitting = false; btn.removeAttribute('aria-busy'); }, 1200);
        }
      });
    }

    root.orthomenCleanup = function () {
      document.removeEventListener('orthomen:variant', onVariant);
      document.removeEventListener('orthomen:qty', onQty);
      if (root.orthomenObserver) root.orthomenObserver.disconnect();
      document.body.style.paddingBottom = '';
    };
  }

  /* ================= MARQUEE ================= */
  function initMarquee(root) {
    if (root.dataset[INIT_FLAG]) return;
    root.dataset[INIT_FLAG] = 'true';
    var marquee = root.querySelector('.orthomen-marquee--animate');
    if (!marquee) return;
    var track = marquee.querySelector('.orthomen-marquee__track');
    var group = marquee.querySelector('.orthomen-marquee__group');
    if (!track || !group) return;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) return;
    var clones = Math.max(1, Math.ceil(marquee.offsetWidth / Math.max(group.offsetWidth, 1)));
    for (var i = 0; i <= clones; i++) {
      var clone = group.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('data-clone', 'true');
      track.appendChild(clone);
    }
    var speedFactor = parseFloat(marquee.dataset.speed || '30');
    var duration = Math.max(8, group.offsetWidth / Math.max(speedFactor, 1));
    marquee.style.setProperty('--o-marquee-speed', duration + 's');
  }

  /* ================= bootstrap + editor lifecycle ================= */
  function initAll(scope) {
    (scope || document).querySelectorAll('[data-orthomen-hero]').forEach(initHero);
    (scope || document).querySelectorAll('[data-orthomen-sticky-section]').forEach(initSticky);
    (scope || document).querySelectorAll('[data-orthomen-marquee-section]').forEach(initMarquee);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    var target = e.target.querySelector('[data-orthomen-hero], [data-orthomen-sticky-section], [data-orthomen-marquee-section]');
    if (target) { delete target.dataset[INIT_FLAG]; }
    initAll(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-orthomen-hero], [data-orthomen-sticky-section]').forEach(function (el) {
      if (typeof el.orthomenCleanup === 'function') el.orthomenCleanup();
    });
  });
  document.addEventListener('shopify:section:select', function (e) {
    var sticky = e.target.querySelector('.orthomen-sticky');
    if (sticky) { sticky.classList.add('is-visible'); }
    var marquee = e.target.querySelector('.orthomen-marquee--animate');
    if (marquee) marquee.classList.add('orthomen-marquee--paused');
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var marquee = e.target.querySelector('.orthomen-marquee--animate');
    if (marquee) marquee.classList.remove('orthomen-marquee--paused');
  });
  document.addEventListener('shopify:block:select', function (e) {
    var details = e.target.closest('details') || e.target.querySelector('details');
    if (details) details.open = true;
    var slideThumb = e.target.closest('[data-thumb]');
    if (slideThumb) slideThumb.click();
  });

 
 /* ===== Kaching Bundles → Orthomen price bridge ===== */
(function () {
  function syncPrice() {
    var priceText = null;
    var compareText = '';

    // Option 1: A .kaching-bundles__bar has the --selected class (quantity tiles + subscribe row)
    /*var selectedBar = document.querySelector('.kaching-bundles__bar--selected');
    if (selectedBar) {
      var p = selectedBar.querySelector('.kaching-bundles__bar-price');
      var c = selectedBar.querySelector('.kaching-bundles__bar-full-price');
      priceText = p ? p.childNodes[0] && p.childNodes[0].textContent.trim() || p.textContent.trim() : null;
      compareText = c ? c.childNodes[0] && c.childNodes[0].textContent.trim() || c.textContent.trim() : '';
    }
	*/
	
	var oneTimeCard = document.querySelector('.kaching-bundles__subscriptions__card.kaching-bundles__bar-container');
	if (oneTimeCard) {
		var selectedBar = document.querySelector('.kaching-bundles__subscriptions .kaching-bundles__bar--selected');
		  var p = selectedBar.querySelector('.kaching-bundles__bar-price');
		  var c = selectedBar.querySelector('.kaching-bundles__bar-full-price');
		  priceText = p ? p.childNodes[0] && p.childNodes[0].textContent.trim() || p.textContent.trim() : null;
		  compareText = c ? c.childNodes[0] && c.childNodes[0].textContent.trim() || c.textContent.trim() : '';
    }
	
	
	console.log(priceText)

    if (!priceText) return;

    // Strip any Vue/comment node artifacts
    priceText = priceText.replace(/<!---->/g, '').trim();
    compareText = compareText.replace(/<!---->/g, '').trim();

    var orthomenPrice = document.querySelector('[data-orthomen-price]');
    var orthomenCompare = document.querySelector('[data-orthomen-compare]');
    var orthomenBadge = document.querySelector('[data-orthomen-badge]');

    if (orthomenPrice) orthomenPrice.textContent = priceText;
    if (orthomenCompare) orthomenCompare.textContent = compareText;

    if (orthomenBadge) {
      var badgePrefix = orthomenBadge.dataset.savePrefix || 'Save';
      var price = parseFloat(priceText.replace(/[^0-9.]/g, ''));
      var compare = parseFloat(compareText.replace(/[^0-9.]/g, ''));
      if (compare && compare > price) {
        var symbol = priceText.replace(/[\d.,\s]/g, '').trim() || '$';
        orthomenBadge.textContent = badgePrefix + ' ' + symbol + (compare - price).toFixed(2);
      } else {
        orthomenBadge.textContent = '';
      }
    }
  }

  function attachListeners() {
    // Covers: quantity tiles, subscribe bar, one-time card
    var clickTargets = document.querySelectorAll(
      '.kaching-bundles__bar, .kaching-bundles__subscriptions__card'
    );
    if (!clickTargets.length) return false;

    clickTargets.forEach(function (el) {
      el.addEventListener('click', function () {
        setTimeout(syncPrice, 80);
      });
    });

    syncPrice(); // sync on load with default selection
    return true;
  }

  function init() {
    if (!attachListeners()) {
      var attempts = 0;
      var interval = setInterval(function () {
        attempts++;
        if (attachListeners() || attempts > 40) clearInterval(interval);
      }, 250);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();



})();
